const { colors } = require("gatsby-theme-apollo-core/src/utils/colors");

exports.colors = {
  ...colors,
  primary: "#2075d6",
};